import React from 'react';
import _ from 'lodash';
import DocumentTabRow from './DocumentTabRow';
import Arrays from '../../../utils/Arrays';
import { PsTable } from '../../table/PsTable';
import PropTypes from 'prop-types';

export default class DocumentsTabTable extends React.Component {

    buildHeader() {
        let checkedAll = false;
        if ( this.props.data || this.props.data.length > 0 ) {
            const nonSelectedElements = this.props.data.filter(element => !Arrays.contains(this.props.selectedIds, element.id));
            checkedAll = nonSelectedElements.length === 0;
        }
        return DocumentTabRow.renderHead(this.props.id, this.props.selectedIds !== null, checkedAll, (checked) => this.props.actionSelectAll(this.props.data, checked));
    }

    render() {

        if ( this.props.error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.error}</h3>
                </section>
            );
        }
        if ( !this.props.data || this.props.data.length === 0 ) {
            return null;
        }
        return (
            <PsTable headings={this.buildHeader()}>
                {
                    _.map(this.props.data, (object, i) =>
                        <DocumentTabRow
                            id={this.props.id}
                            hideOutsource={this.props.hideOutsource}
                            key={i}
                            document={object}
                            selectedIds={this.props.selectedIds}
                            actionSelectItem={this.props.actionSelectItem}
                        />,
                    )
                }
            </PsTable>
        );
    }

}

DocumentsTabTable.propTypes = {
    id: PropTypes.string.isRequired,
    data: PropTypes.any,
    error: PropTypes.string,

    selectedIds: PropTypes.array,
    actionSelectItem: PropTypes.func,
    actionSelectAll: PropTypes.func,
};

DocumentsTabTable.defaultProps = {
    selectedIds: null,
    actionSelectItem: () => {},
    actionSelectAll: () => {},
};



// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/documents/DocumentsTabTable.jsx